export default () => {


    // history.js
    document.addEventListener('DOMContentLoaded', () => {
        const section = document.querySelector('[data-history]');
        if (!section) return;

        const cardsContainer = section.querySelector('#js-historyCards') || section;

        const jsonUrl = section.dataset.src || 'history.json';
        const imgBase = section.dataset.imgBase || '';

        cardsContainer.innerHTML = '<p class="history__loading">読み込み中…</p>';

        fetch(jsonUrl)
            .then(res => {
                if (!res.ok) throw new Error(`HTTP error! ${res.status}`);
                return res.json();
            })
            .then(items => {
                cardsContainer.innerHTML = '';

                if (!Array.isArray(items) || items.length === 0) {
                    cardsContainer.innerHTML =
                        '<p class="history__empty">現在、表示できるコンテンツがありません。</p>';
                    return;
                }

                const frag = document.createDocumentFragment();

                items.forEach(item => {
                    const { link, title, text, pic } = item;

                    const card = document.createElement('div');
                    card.className = 'historyCard reveal';   // Observer対象

                    const a = document.createElement('a');
                    a.className = 'historyCard__link';
                    a.href = link || '#';
                    if (title) a.setAttribute('aria-label', title);

                    // 画像
                    if (pic && pic.trim() !== '') {
                        const figure = document.createElement('figure');
                        figure.className = 'historyCard__figure';

                        const img = document.createElement('img');
                        img.className = 'historyCard__img';

                        // ★遅延ロード
                        img.dataset.src = imgBase + pic;
                        img.alt = title || '';

                        figure.appendChild(img);
                        a.appendChild(figure);
                    }

                    // テキスト
                    const body = document.createElement('div');
                    body.className = 'historyCard__body';

                    if (title) {
                        const h3 = document.createElement('h3');
                        h3.className = 'historyCard__title';
                        h3.innerHTML = title;
                        body.appendChild(h3);
                    }
                    if (text) {
                        const p = document.createElement('p');
                        p.className = 'historyCard__text';
                        p.innerHTML = text;
                        body.appendChild(p);
                    }

                    a.appendChild(body);
                    card.appendChild(a);
                    frag.appendChild(card);
                });

                cardsContainer.appendChild(frag);

                // === 遅延ロード＆フェードイン ===
                initReveal();
            })
            .catch(err => {
                console.error(err);
                cardsContainer.innerHTML =
                    '<p class="history__error">コンテンツの読み込みに失敗しました。</p>';
            });
    });


    // ===== IntersectionObserver =====
    function initReveal() {
        const targets = document.querySelectorAll('.reveal');

        const onReveal = el => {
            // ↓ img遅延ロード
            const imgs = el.querySelectorAll('img[data-src]');
            imgs.forEach(img => {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
            });

            // ↓ フェードイン
            el.classList.add('is-visible');
        };

        if (!('IntersectionObserver' in window)) {
            targets.forEach(onReveal);
            return;
        }

        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                onReveal(entry.target);
                obs.unobserve(entry.target);
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -10% 0px'
        });

        targets.forEach(el => observer.observe(el));
    }


}
